var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-framework";
import { UserModel } from "../../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { SourceType, DataType } from "../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { Router } from "aurelia-router";
import moment from "moment";
import { BaseTransactionVideo } from "../../transaction/base/base-transaction-video";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
var TicketDrawBasicMeta = /** @class */ (function (_super) {
    __extends(TicketDrawBasicMeta, _super);
    function TicketDrawBasicMeta(notificationService, i18N, tokenClient, queriesService, router) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        _this.queriesService = queriesService;
        _this.router = router;
        return _this;
    }
    TicketDrawBasicMeta.prototype.onActivated = function (item) {
        this.reLoad();
        this.getSessionVideo(item.gamePlayerTicketLine.recordedSessionId);
    };
    TicketDrawBasicMeta.prototype.reLoad = function () {
        this.loadGamePlayerTicketLineOdata();
        this.loadGamePlayerTicketLineDrawsOdata();
        this.loadGamePlayerStatusesOdata();
    };
    TicketDrawBasicMeta.prototype.loadGamePlayerTicketLineOdata = function () {
        var _this = this;
        var ticketLinePath = 'TicketLines';
        var odataUrl = "/odata/".concat(ticketLinePath, "?$filter=gamePlayerTicketLineId eq ").concat(this.item.gamePlayerTicketLineId);
        this.queriesService.getEntityModels().then(function (models) {
            var e_1, _a;
            var columns = [];
            var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == ticketLinePath; });
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                    UserModel.enableAgentColumnNameReplacement(_this.tokenClient.user, column);
                    columns.push(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.queriesService.getData(odataUrl).then(function (lotteryDataResponse) {
                _this.ticketLineItemSource = {
                    source: lotteryDataResponse.value,
                    sourceType: SourceType.Collection,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    TicketDrawBasicMeta.prototype.loadGamePlayerTicketLineDrawsOdata = function () {
        var _this = this;
        var ticketLinePath = 'TicketLineDraws';
        var odataUrl = "/odata/".concat(ticketLinePath, "?$filter=gamePlayerTicketLineId eq ").concat(this.item.gamePlayerTicketLineId);
        this.queriesService.getEntityModels().then(function (models) {
            var e_2, _a;
            var columns = [];
            var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == ticketLinePath; });
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                    UserModel.enableAgentColumnNameReplacement(_this.tokenClient.user, column);
                    columns.push(column);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            _this.queriesService.getData(odataUrl).then(function (lotteryDataResponse) {
                _this.ticketLineDrawitemSource = {
                    source: lotteryDataResponse.value,
                    sourceType: SourceType.Collection,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    TicketDrawBasicMeta.prototype.loadGamePlayerStatusesOdata = function () {
        this.ticketLineStatusesitemSource = {
            sourceType: SourceType.Collection,
            source: this.item.gamePlayerTicketLine.gamePlayerTicketLineStatusLogs,
            columns: this.getColumnNames()
        };
    };
    TicketDrawBasicMeta.prototype.getColumnNames = function () {
        var columns = [
            {
                name: "dateCreated",
                title: this.i18N.tr("date-created"),
                valueConverter: function (date) { return moment(date).format("DD/MM/YYYY hh:mm A"); },
                dataType: DataType.DateTime,
                sortOrder: 0,
                columnOrder: 0,
                isFilterable: true
            },
            {
                name: "effectiveDate",
                title: this.i18N.tr("effective-date"),
                dataType: DataType.DateTime,
                sortOrder: 1,
                columnOrder: 1,
                isFilterable: true,
                valueConverter: function (date) { return moment(date).format("DD/MM/YYYY hh:mm A"); },
            },
            {
                name: "previousStatus",
                title: this.i18N.tr("previous-status"),
                dataType: DataType.Lookup,
                sortOrder: 2,
                parameter: "ticketLineStatuses",
                columnOrder: 2,
                isFilterable: true
            },
            {
                name: "newStatus",
                title: this.i18N.tr("new-status"),
                dataType: DataType.Lookup,
                parameter: "ticketLineStatuses",
                sortOrder: 3,
                columnOrder: 3,
                isFilterable: true
            },
        ];
        return columns;
    };
    TicketDrawBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            TokenClient,
            QueriesClientService, Router])
    ], TicketDrawBasicMeta);
    return TicketDrawBasicMeta;
}(BaseTransactionVideo));
export { TicketDrawBasicMeta };
